module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1n3n6n-f32c550d6d3c81544870a9089078a5d7.svg";